import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import product from '@/components/product'
import group from '@/components/group'
import AboutUs from '@/components/AboutUs'
import AboutUsDetail from '@/components/AboutUsDetail'
import imgViews from "@/components/imgViews"
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/group',
      name: 'group',
      component: group
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/AboutUsDetail',
      name: 'AboutUsDetail',
      component: AboutUsDetail
    },
    {
      path: '/imgViews',
      name: 'imgViews',
      component: imgViews
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js


// WEBPACK FOOTER //
// ./src/router/index.js